import React from 'react';

import { TrendingDown, TrendingUp } from '@mui/icons-material';

import ScorePane from 'pages/item/v2/components/Score/components/ScorePane';
import getScoreSeverity from 'utils/get-score-severity';

import useStyles from './styles';

interface Props {
    aiScore: {
        value: number;
        uncertanity: number;
    };
}

const AI: React.FC<Props> = ({ aiScore }) => {
    const { classes, cx } = useStyles();
    const { value, uncertanity } = aiScore;

    if (!value || !uncertanity) {
        return null;
    }

    const isHighConfidence = uncertanity > 0.75;

    return (
        <ScorePane
            score={value}
            name="AI Score"
            severity={getScoreSeverity(value)}
            vectorItems={{
                confidence: (
                    <span
                        className={cx(classes.confidence, {
                            [classes.high]: isHighConfidence,
                            [classes.low]: !isHighConfidence
                        })}
                    >
                        {isHighConfidence ? <TrendingUp /> : <TrendingDown />}
                        {isHighConfidence ? 'High' : 'Low'}
                    </span>
                )
            }}
        />
    );
};

export default AI;
